"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Date;

var _Date = require("@adobe/react-spectrum-workflow/dist/Date");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Date(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Date.A4uDate, null));
}